var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_7",
    "data-name": "Warstwa 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,46.51A21.51,21.51,0,1,1,46.51,25,21.54,21.54,0,0,1,25,46.51Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75,37.25h8.5V12.75h-8.5Zm2.5-22h3.5v19.5h-3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75,12.75v24.5h8.5V12.75Zm6,22h-3.5V15.25h3.5Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7919330a9721ea20bc25401af7ce749c.svg";
export { ForwardRef as ReactComponent };